"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Sentry = __importStar(require("@sentry/react"));
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const react_native_1 = require("react-native");
const config_1 = require("../../../web/config");
const AnalyticsComponent = ({ children }) => {
    react_1.useEffect(() => {
        if (config_1.PRODUCTION) {
            Sentry.init({
                dsn: config_1.SENTRY_DSN,
                environment: react_native_1.Platform.OS,
                tracesSampleRate: 1.0,
                normalizeDepth: 10,
                autoSessionTracking: false,
            });
        }
        mixpanel_browser_1.default.init(config_1.MIXPANEL_TOKEN);
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = AnalyticsComponent;
